import React, {useEffect, useState} from 'react';
import "./gallery.css"
import Layout from "../../component/layout/layout";
import Line from "../../component/line/line";
import Api from "../../services/api";
import {toast} from "react-toastify";
import {ENV} from "../../services/env"
import videoIcon from "../../res/img/video.png"
import Pagination from "react-js-pagination";
import queryString from "query-string";
import {useHistory, useLocation, useParams} from "react-router-dom";
import Loading from "../../component/loading/loading";
import { saveAs } from 'file-saver'
import ContentBox from "../../component/contentBox/contentBox";


const Gallery = () => {
    const location = useLocation();
    const history = useHistory()

    const query = queryString.parse(location && location.search);

    const [galleryList, setGalleryList] = useState([])
    const [modalGallery, setModalGallery] = useState(false)
    const [imageSrc, setImageSrc] = useState(false)
    const [fileType, setFileType] = useState("")
    const [page, setPage] = useState(query.page || null)
    const [loading, setLoading] = useState(false)

    const param = useParams()

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"})
        setPage(query.page || 1)
        getGallery(query.page || 1)
    }, [param])


    const handlePageChange = async (active) => {
        setPage(active)
        window.scrollTo({top:0 , behavior:"smooth"})
        await history.push(`/gallery${param.id ? "/category/video/" + param.id : "/video"}`)
        getGallery(active)
    }

    const getGallery = () => {
        setLoading(true)
        new Api().get(`/gallery${param.id ? "/category/video/" + param.id : "/video"}`)
            .then((res) => {
                setLoading(false)
                setGalleryList(res)
            })
            .catch((err) => {
                setLoading(false)
                toast.error(err)
            })
    }
    return (
        <Layout>
            <div className={"container"}>
                <div className={"gallery"}>
                    {
                        loading ?
                            <Loading />
                              :
                            <>
                                {
                                    galleryList && galleryList.list && galleryList.list.length === 0 ? "مطلبی برای نمایش وجود ندارد"
                                        :
                                        galleryList && galleryList.list && galleryList.list.map((item) => {
                                        return (
                                            <ContentBox
                                                route={"gallery"}
                                                title={item.title}
                                                image={item.image}
                                                description={item.description}
                                                slug={item.slug}
                                                id={item._id}
                                                type={item.type}
                                                file={item.file}
                                            />
                                        )
                                    })
                                }
                            </>
                    }
                </div>
                {
                    galleryList.totalPage > 1 &&
                    <div className={"pagination"}>
                        <Pagination
                            activePage={+page || 1}
                            itemsCountPerPage={galleryList.per_page}
                            totalItemsCount={galleryList.total}
                            onChange={handlePageChange}
                        />
                    </div>
                }
            </div>
        </Layout>
    );
};

export default Gallery;
